// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 509 ? "ai-chat-panel" : chunkId) + "." + {"271":"871225f5","509":"41283d6b","513":"41283d6b","703":"4849b65f","711":"00c806e3","941":"f3e0363e"}[chunkId] + ".chunk.css";
};